
import { useEffect, useRef, useState } from 'react';

export default function CaseResults() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const stats = [
    {
      number: '+38%',
      label: 'Increase in Booked Consultations',
      icon: 'ri-calendar-check-line',
    },
    {
      number: '+52%',
      label: 'Faster Client Response Time',
      icon: 'ri-time-line',
    },
    {
      number: '+27%',
      label: 'Revenue Lift in 90 Days',
      icon: 'ri-arrow-up-line',
    },
  ];

  return (
    <section
      ref={sectionRef}
      id="results"
      className="relative bg-[#0B0D10] py-32 overflow-hidden"
    >
      {/* Full‑bleed background visual */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9c20520457a07d4632286cc4818c0791.jpg"
          alt="Performance Data"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#0B0D10]/85"></div>
      </div>

      <div
        className={`relative z-10 max-w-7xl mx-auto px-6 transition-all duration-1000 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <div className="text-center mb-20">
          <p className="text-xs font-semibold tracking-[0.35em] text-[#8C9198] mb-5 uppercase">
            Proven Results
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight">
            Performance, Measured
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className={`group relative bg-white/5 backdrop-blur-sm rounded-3xl p-12 text-center transition-all duration-700 hover:bg-white/8 cursor-pointer ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${(index + 1) * 200}ms` }}
            >
              <div className="w-14 h-14 mx-auto mb-8 flex items-center justify-center rounded-2xl bg-white/5">
                <i
                  className={`${stat.icon} text-3xl text-white/70 transition-all duration-300 group-hover:text-white`}
                ></i>
              </div>

              <div className="text-6xl md:text-7xl font-bold mb-4 bg-gradient-to-b from-white to-[#8C9198] bg-clip-text text-transparent tracking-tight">
                {stat.number}
              </div>

              <p className="text-sm text-[#8C9198] font-light leading-relaxed">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
